<job-edit-form [model]="model | async" [users]="users | async | active" (onSave)="saveJob($event)" [appSettings]="appSettings" [view]="view"></job-edit-form>
